export default __webpack_public_path__ + "static/10.04-2-71487fb6d1e6ba3d1caa0037f0d61946.png";